import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_3 = {
  key: 2,
  class: "ml-1"
}
const _hoisted_4 = { class: "x-dense" }
const _hoisted_5 = {
  class: "text-start",
  colspan: "20"
}
const _hoisted_6 = {
  style: {"width":"100%"},
  class: "d-flex align-center"
}
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "bottom-sheet" }
const _hoisted_9 = {
  class: "remote",
  style: {"pointer-events":"auto"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_AccountableAccount = _resolveComponent("AccountableAccount")!
  const _component_CreateBTChatMessage = _resolveComponent("CreateBTChatMessage")!
  const _component_OssDataTable = _resolveComponent("OssDataTable")!
  const _component_document = _resolveComponent("document")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_Reconciliation = _resolveComponent("Reconciliation")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_MailerDialog = _resolveComponent("MailerDialog")!
  const _component_PaymentManagement = _resolveComponent("PaymentManagement")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_OssDataTable, {
      headers: _ctx.headers,
      items: _ctx.accountingTransactions,
      loading: _ctx.loading,
      striped: true,
      dense: true,
      height: _ctx.height,
      showSelect: _ctx.addCheckBoxColumn,
      "fixed-header": "",
      "fixed-footer": true,
      "item-key": "index",
      displayRowNumber: true,
      modelValue: _ctx.selectedAccountingTransactionKeys,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedAccountingTransactionKeys) = $event)),
      checkboxDisplayCondition: _ctx.isCheckable,
      onClickRow: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openAccountingTransaction($event)))
    }, {
      "item.status": _withCtx(({ item }) => [
        (_ctx.statusIcon(item) || item.stillOwe)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              color: _ctx.statusColor(item),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.statusIcon(item)), 1)
              ]),
              _: 2
            }, 1032, ["color"]))
          : _createCommentVNode("", true),
        (item.stillOwe)
          ? (_openBlock(), _createElementBlock("a", _hoisted_2, _toDisplayString(_ctx.status(item)), 1))
          : _createCommentVNode("", true),
        (item.mail)
          ? (_openBlock(), _createElementBlock("a", _hoisted_3, _toDisplayString(_ctx.formatMailStatus(item.mail)), 1))
          : _createCommentVNode("", true)
      ]),
      "item.type": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.getItemLog(item)), 1)
      ]),
      "item.wording": _withCtx(({ item }) => [
        (item.tags)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.tags, (tag, index) => {
              return (_openBlock(), _createBlock(_component_v_chip, {
                label: "",
                ripple: false,
                key: index,
                class: "text mr-1",
                size: "x-small"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    style: _normalizeStyle('color:' + _ctx.labelTextColor + ';')
                  }, _toDisplayString(tag.name), 5)
                ]),
                _: 2
              }, 1024))
            }), 128))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(item.wording + (item.invoiceNumber ? " - " + item.invoiceNumber : "")), 1)
      ]),
      "item.date": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.formatDate(item.date)), 1)
      ]),
      "item.amountSigned": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.debit - item.credit, undefined)), 1)
      ]),
      "item.stillOwe": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.formatStillOwe(item.stillOwe, item.object.type)), 1)
      ]),
      "item.action": _withCtx(({ item }) => [
        (
                        item.object.type === 'document' ||
                        _ctx.isBankTransactionWaitingClientResponse(item)
                    )
          ? (_openBlock(), _createBlock(_component_v_menu, {
              key: 0,
              location: "start"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_tooltip, _mergeProps({ location: "top" }, props), {
                  activator: _withCtx(({ props: propsTT }) => [
                    _createVNode(_component_v_btn_icon, _mergeProps({ ...propsTT, ...props }, {
                      size: "small",
                      icon: "$dots_vertical"
                    }), null, 16)
                  ]),
                  default: _withCtx(() => [
                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "Plus d'options", -1))
                  ]),
                  _: 2
                }, 1040)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, { density: "compact" }, {
                  default: _withCtx(() => [
                    (_ctx.isBankTransactionWaitingClientResponse(item))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          onClick: _withModifiers(($event: any) => (_ctx.$emit('bankTransactionSelected', item.object.id)), ["stop"])
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "x-small" }, {
                              default: _withCtx(() => _cache[23] || (_cache[23] = [
                                _createTextVNode("$oss-chat")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[22] || (_cache[22] = [
                                _createTextVNode("Répondre")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.isBankTransactionWaitingClientResponse(item))
                      ? (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
                      : _createCommentVNode("", true),
                    (item.object.type === 'document')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createVNode(_component_v_tooltip, {
                            location: "top",
                            disabled: item.object.original
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createElementVNode("div", _mergeProps(props, { class: "d-inline-block" }), [
                                (_ctx.isForClients)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      disabled: !item.object.original,
                                      onClick: ($event: any) => (_ctx.openMailDialog(item, false))
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "x-small" }, {
                                          default: _withCtx(() => _cache[25] || (_cache[25] = [
                                            _createTextVNode("$oss-mail")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                                            _createTextVNode("Envoi de la facture")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"]))
                                  : _createCommentVNode("", true)
                              ], 16)
                            ]),
                            default: _withCtx(() => [
                              _cache[26] || (_cache[26] = _createElementVNode("span", null, "Pas de facture", -1))
                            ]),
                            _: 2
                          }, 1032, ["disabled"]),
                          (_ctx.isForClients)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                onClick: ($event: any) => (_ctx.openReminderMailDialog(item, true, 1))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                                      _createTextVNode("Relance 1")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.isForClients)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                onClick: ($event: any) => (_ctx.openReminderMailDialog(item, true, 2))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                                      _createTextVNode("Relance 2")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.isForClients)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 2,
                                onClick: ($event: any) => (_ctx.openReminderMailDialog(item, true, 3))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                                      _createTextVNode("Relance 3")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_tooltip, {
                            location: "top",
                            disabled: _ctx.mails.length > 0
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createElementVNode("div", _mergeProps(props, { class: "d-inline-block" }), [
                                _createVNode(_component_v_list_item, {
                                  disabled: _ctx.mails.length === 0,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accessToMails()))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                                        _createTextVNode("Accéder à la correspondance")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ], 16)
                            ]),
                            default: _withCtx(() => [
                              _cache[31] || (_cache[31] = _createElementVNode("span", null, "Pas de correspondance", -1))
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true)
      ]),
      "body.append": _withCtx(() => [
        _createElementVNode("tr", _hoisted_4, [
          _createElementVNode("td", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (
                                    _ctx.addCheckBoxColumn &&
                                    !!_ctx.accountableAccountReplacementRule &&
                                    _ctx.accountableAccountInfo.name === '471000'
                                )
                ? (_openBlock(), _createBlock(_component_AccountableAccount, {
                    key: 0,
                    showLabel: true,
                    needValidation: true,
                    showValidation: false,
                    companyId: _ctx.companyId,
                    accountableAccountReplacementRule: 
                                    _ctx.accountableAccountReplacementRule
                                ,
                    inAccountableAccount: _ctx.accountableAccountInfo,
                    "btn-mode": true,
                    label: _ctx.modifyAATitle,
                    disabled: 
                                    !_ctx.selectedAccountingTransactionCount || !_ctx.enableModification
                                ,
                    thirdParty: _ctx.thirdPartyCompany || _ctx.user,
                    defineThirdParty: true,
                    onValidated: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validAA($event))),
                    onDialogClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openAccountableAccountDialog = false))
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps(props, {
                        rounded: "",
                        class: "ml-2",
                        color: "ternary",
                        elevation: "0",
                        disabled: !_ctx.selectedAccountingTransactionCount,
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openAccountableAccountDialog = true), ["stop"])),
                        size: "x-small"
                      }), {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.modifyAATitle), 1)
                        ]),
                        _: 2
                      }, 1040, ["disabled"])
                    ]),
                    _: 1
                  }, 8, ["companyId", "accountableAccountReplacementRule", "inAccountableAccount", "label", "disabled", "thirdParty"]))
                : _createCommentVNode("", true),
              (_ctx.addCheckBoxColumn && _ctx.openPointMode)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    rounded: "circle",
                    color: "ternary",
                    elevation: "0",
                    disabled: !_ctx.selectedBankTransactionsForMessage.length,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCreateBankTransactionMessageDialog = true)),
                    class: "ml-2",
                    size: "x-small",
                    icon: "$fa-comments"
                  }, null, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_ctx.addCheckBoxColumn && _ctx.openPointMode)
                ? (_openBlock(), _createBlock(_component_CreateBTChatMessage, {
                    key: 2,
                    active: _ctx.showCreateBankTransactionMessageDialog,
                    "onUpdate:active": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showCreateBankTransactionMessageDialog) = $event)),
                    companyId: _ctx.selectedCompany.id,
                    bankTransactions: _ctx.selectedBankTransactionsForMessage,
                    onMessageCreated: _cache[6] || (_cache[6] = ($event: any) => (_ctx.refresh($event)))
                  }, {
                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                      _createTextVNode(" > ")
                    ])),
                    _: 1
                  }, 8, ["active", "companyId", "bankTransactions"]))
                : _createCommentVNode("", true),
              (_ctx.addCheckBoxColumn && _ctx.showPaymentManager)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 3,
                    rounded: "",
                    elevation: "0",
                    class: "ml-2",
                    disabled: _ctx.disabledPaymentManager,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    _ctx.reminder = true;
                                    _ctx.paymentManagerDialog = true;
                                }),
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[33] || (_cache[33] = [
                      _createTextVNode(" Gérer ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["headers", "items", "loading", "height", "showSelect", "modelValue", "checkboxDisplayCondition"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.showAccountingTransactionDialog,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showAccountingTransactionDialog) = $event)),
      withoutHeader: true,
      transition: "dialog-bottom-transition",
      onClose: _ctx.closeDocRecDialog,
      height: "100vh",
      width: "100vw",
      hideValid: _ctx.showDocument ? true : false
    }, {
      default: _withCtx(() => [
        (_ctx.showDocument)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  style: {"overflow-y":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_document, {
                      mode: 'GeneralLedger',
                      companyId: _ctx.selectedCompany.id,
                      id: _ctx.documentId,
                      "dark-mode": true,
                      onReload: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onDocumentUpdated())),
                      onDeleted: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onDocumentDeleted())),
                      onTaskEnded: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onDocumentUpdated()))
                    }, null, 8, ["companyId", "id"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showReconciliation)
          ? (_openBlock(), _createBlock(_component_Reconciliation, {
              key: 1,
              mode: 'GeneralLedger',
              companyId: _ctx.selectedCompany.id,
              bankTransactionId: _ctx.bankTransactionId,
              reconciliationId: _ctx.reconciliationId,
              onUpdate: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onReconciliationUpdated()))
            }, null, 8, ["companyId", "bankTransactionId", "reconciliationId"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_v_container, { class: "controller elevation-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_prev, {
                    disabled: _ctx.previousDisabled(),
                    onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.previous()), ["stop"]))
                  }, null, 8, ["disabled"]),
                  _createVNode(_component_v_btn_next, {
                    disabled: _ctx.nextDisabled(),
                    onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.next()), ["stop"]))
                  }, null, 8, ["disabled"])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose", "hideValid"]),
    (_ctx.sendMailDialog)
      ? (_openBlock(), _createBlock(_component_MailerDialog, {
          key: 0,
          modelValue: _ctx.sendMailDialog,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.sendMailDialog) = $event)),
          mailType: _ctx.documentDefaultMailerInfos.mailType,
          defaultSubject: _ctx.documentDefaultMailerInfos.defaultSubject,
          defaultText: _ctx.documentDefaultMailerInfos.defaultText,
          companyId: _ctx.companyId,
          thirdPartyCompanyId: _ctx.thirdPartyCompanyId,
          listDocuments: _ctx.resetedSelectedAccountingTransactions,
          withAttachment: _ctx.documentDefaultMailerInfos.withAttachment
        }, null, 8, ["modelValue", "mailType", "defaultSubject", "defaultText", "companyId", "thirdPartyCompanyId", "listDocuments", "withAttachment"]))
      : _createCommentVNode("", true),
    (_ctx.paymentManagerDialog)
      ? (_openBlock(), _createBlock(_component_PaymentManagement, {
          key: 1,
          modelValue: _ctx.paymentManagerDialog,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.paymentManagerDialog) = $event)),
          companyId: _ctx.companyId,
          inThirdPartyName: _ctx.thirdPartyName,
          inThirdPartyCompanyId: _ctx.thirdPartyCompanyId,
          inThirdPartyUserId: _ctx.thirdPartyUserId,
          inAccountableAccountName: _ctx.accountableAccountInfo.name,
          inAccountingTransactions: _ctx.resetedSelectedAccountingTransactions,
          forCustomer: _ctx.isForClients,
          onActionDone: _ctx.onActionDone
        }, null, 8, ["modelValue", "companyId", "inThirdPartyName", "inThirdPartyCompanyId", "inThirdPartyUserId", "inAccountableAccountName", "inAccountingTransactions", "forCustomer", "onActionDone"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.switchResultDialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.switchResultDialog) = $event)),
      title: 'Notification',
      validTitle: 'J\'ai compris',
      onValid: _cache[20] || (_cache[20] = ($event: any) => (_ctx.switchResultDialog = false)),
      width: "800px"
    }, {
      default: _withCtx(() => [
        (
                    _ctx.switchResult &&
                    _ctx.switchResult.accountingLines &&
                    _ctx.switchResult.accountingLines.length === 0
                )
          ? (_openBlock(), _createElementBlock("h3", _hoisted_10, " L'affectation n'a pu être effectuée sur aucune écriture car elle(s) est/sont lettrée(s) avec des écritures d'un exercice clos "))
          : (_openBlock(), _createElementBlock("h3", _hoisted_11, " L'affectation n'a pu être effectuée sur certaines écriture(s) car elle(s) est/sont lettrée(s) avec des écritures d'un exercice clos ")),
        _cache[34] || (_cache[34] = _createElementVNode("h4", null, "Intangibilité du bilan d'ouverture", -1))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}